/* eslint-disable import/prefer-default-export */
export const trans = [
    {
        normal: `1-Tolerância ao exame:
         Após sedação tópica com lidocaina-spray a 10% e endovenosa com dormonid, a sonda multiplanar foi introduzida sem dificuldades e o exame foi bem tolerado.

2-Cavidades Cardíacas:
         Átrio direito com dimensões normais.
         Ventrículo direito com dimensões, espessura e funções normais.
         Átrio esquerdo com dimensões normais.
         Ventrículo esquerdo com dimensões, espessura e funções normais.
         Ausência de massas, trombos ou contraste espontâneo intracavitário.

3-Valvas Cardíacas:
         Valva mitral com abertura, mobilidade e espessura normais.
         Valva aórtica com abertura, mobilidade e espessura normais.
         Valva tricúspide com abertura, mobilidade e espessura normais.
         Valva pulmonar com abertura, mobilidade e espessura normais.
         Ausência de vegetações.
         Ao estudo doppler com mapeamento de fluxo a cores, fluxos normais.

4-Septos e veias:
         Septo interatrial íntegro sem shunt.
         Septo interventricular íntegro sem shunt.
         Veias cavas com drenagem e fluxos normais.
         Veias pulmonares com drenagem e fluxos normais.

5-Artérias:
         Artéria Aorta com dimensões e morfologia normais.
         Artéria Pulmonar com dimensões e morfologia normais.

6-Pericárdio:
         Com aspecto e espessura normais, sem derrame.


CONCLUSÃO:  Normal sob aspecto anatômico.
`,
    },
];